import { useTranslation } from 'react-i18next';
import './RoleSelectionDialog.css';

const RoleCard = ({ data, handleSelectRole, isSelected }) => {
    const { t } = useTranslation();

    return (
        <div
            disabled={isSelected}
            className={`role-card-container ${isSelected ? 'selected' : ''}`}
            onClick={isSelected ? () => { } : () => handleSelectRole()}
        >
            <div className="role-card-title">{isSelected ? `${data?.roleName} (Τωρινή Επιλογή)` : data?.roleName}</div>
            <div className="role-card-detail">{data?.functionName}</div>
            <div className="role-card-status">{data?.orgName}</div>
        </div>
    );
};

export default RoleCard;
